import { useContext, useEffect, useState } from "react"

import { useLocalSearchParams } from "expo-router"

import { ContributionLimit, ContributionLimitCollection, Index } from "wealthmode-frontend/backend"
import { formatMoneyFull } from "wealthmode-frontend/util"

import { DetailField, ResourceDetail } from "@/components"
import { BackendContext } from "@/context"
import { contributionLimitKindLabel } from "@/lib/labels"

export default function ContributionLimitDetail() {
  const { contribution_limit_id } = useLocalSearchParams<{ contribution_limit_id: string }>()

  const backend = useContext(BackendContext)

  const [limit, setLimit] = useState<ContributionLimit>()

  useEffect(() => {
    ;(async () => {
      const data = backend.link("data").resolve() as Index
      await data.fetch({ reload: true })

      const limits = data.link("contribution_limits")?.resolve() as ContributionLimitCollection | undefined
      if (!limits) {
        return
      }

      const model = limits.model(contribution_limit_id)
      await model.fetch({ reload: true })

      setLimit(model)
    })().catch((err) => {
      console.error("Error: " + err)
      throw err
    })
  }, [backend, contribution_limit_id])

  const fields: DetailField[] = []

  if (limit) {
    fields.push(
      { label: "Tax Year", value: limit.attributes.tax_year },
      { label: "Kind", value: contributionLimitKindLabel(limit.attributes.kind) },
      { label: "Filing Status", value: limit.attributes.filing_status ?? "Any" },
      { label: "Maximum", value: formatMoneyFull(limit.attributes.maximum) },
    )
  }

  return (
    <ResourceDetail
      title={
        limit
          ? `${limit.attributes.tax_year} ${contributionLimitKindLabel(limit.attributes.kind)}`
          : "Contribution Limit"
      }
      subtitle={contribution_limit_id}
      loading={!limit}
      fields={fields}
      links={[]}
    />
  )
}
